import { z } from "zod";
import { id, instantDateTime } from "./common";

export const ATTACHMENT_MAX_BYTES = 25 * 1024 * 1024;
export const attachmentEntity = z.enum(["booking", "contact", "lead"]);
export const attachmentKind = z.enum(["contract", "coi", "invoice", "receipt", "photo", "floor_plan", "other"]);
export const attachmentQuery = z.object({ entityType: attachmentEntity, entityId: id });
export const attachmentUpload = attachmentQuery.extend({ kind: attachmentKind.default("other"), note: z.string().trim().max(4000).nullable().optional() });
export const attachmentPatch = z.object({ kind: attachmentKind.optional(), note: z.string().trim().max(4000).nullable().optional() }).strict().refine(value => Object.keys(value).length > 0, "Choose an attachment detail to change.");
export const attachmentDownload = z.object({ inline: z.enum(["0", "1"]).optional() });
/** Browser metadata feedback only. The server independently bounds the stream
 * and sniffs bytes; a supplied filename/MIME never authorizes a file type. */
export const attachmentFileMetadata = z.object({ name: z.string().min(1).max(255), size: z.number().int().min(1).max(ATTACHMENT_MAX_BYTES) });
export const attachmentRecord = z.object({
  entityType: attachmentEntity, entityId: id, filename: z.string().min(1).max(180),
  contentType: z.enum(["application/pdf", "image/jpeg", "image/png", "image/heic", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]),
  size: z.number().int().min(1).max(ATTACHMENT_MAX_BYTES), kind: attachmentKind,
  note: z.string().nullable(), uploadedByMemberId: id.nullable(),
  createdAt: instantDateTime, updatedAt: instantDateTime,
});
